import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';

const BusinessIntelligence = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Reporting: {
    Layout: lazy(() => import('./containers/Reporting/index.tsx')),
    Report: lazy(() => import('./containers/Reporting/pages/ReportType/Report/index.tsx')),
    ReportType: lazy(() => import('./containers/Reporting/pages/ReportType/ReportType.tsx')),
    List: lazy(() => import('./containers/Reporting/pages/ReportListPage/index.tsx')),
    ListV2: lazyNamed(() => import('./containers/Reporting/pages/ReportList/index.tsx'), 'ReportList'),
  },
  Visualizations: {
    Widget: lazy(() => import('./containers/Visualizations/Widgets/Form/index.tsx')),
    Widgets: lazy(() => import('./containers/Visualizations/Widgets/List/index.tsx')),
    DashboardView: lazy(() => import('./containers/Visualizations/Dashboards/View/index.tsx')),
    DashboardEdit: lazy(() => import('./containers/Visualizations/Dashboards/Form/index.tsx')),
    Dashboards: lazy(() => import('./containers/Visualizations/Dashboards/List/index.tsx')),
  },
};

export default BusinessIntelligence;
